import { useEffect, useState } from "react";
import useAxios from "../../utils/useAxios";
import axios from "axios";
import { FaSpinner } from "react-icons/fa";
import { hideModal, showModal } from "../../utils/modalUtility";
import Pagination from "../common/pagination";

function Builder() {
  const [properties, setProperties] = useState([]);
  const [builders, setBuilders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isEditMode, setIsEditMode] = useState(false);
  const [currentUserId, setCurrentUserId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [statusList, setStatusList] = useState([]);
  const [noDataFound, setNoDataFound] = useState(false); // Initially false (i.e., assume data is available)
  const [notFoundMessage, setNotFoundMessage] = useState("");
  const axiosAPI = useAxios();

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const [formData, setFormData] = useState({
    fullName: "",
    phoneNumber: "",
    address: "",
    logoUrl: "",
  });

  const removeFormData = () => {
    setFormData({
      fullName: "",
      phoneNumber: "",
      address: "",
      logoUrl: "",
    });
  };

  const getBuilders = async () => {
    try {
      // console.log("Query ",queryString)
      setLoading(true);

      const response = await axiosAPI.get(
        `/api/builder/get-builders?page=${page}`
      );
      const { data, currentPage, totalPages, success } = response.data;

      if (success && Array.isArray(data)) {
        setBuilders(data);
        // setCurrentPage(currentPage);
        setTotalPages(totalPages);
        // setTotalRecords(totalRecords);
        setNotFoundMessage(data.length === 0 ? "No enquiries found." : "");
      } else {
        setBuilders([]);
        setNotFoundMessage("No enquiries found.");
      }
    } catch (err) {
      console.error("Error fetching enquiries:", err);
      setBuilders([]);
      if (err.response?.status === 404) {
        setNotFoundMessage("No enquiries found.");
      } else {
        setNotFoundMessage("Something went wrong. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getBuilders();
  }, [page]);

  // Handle Input Changes
  const handleChange = (e) => {
    console.log(e.target.id, e.target.value);
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  // Handle Submit (Add or Edit)
  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      name: formData.fullName,
      phone_number: formData.phoneNumber,
      address: formData.address,
      logo_url: formData.logoUrl,
    };

    console.log(payload);
    setIsLoading(true);

    try {
      let response;
      if (isEditMode) {
        response = await axiosAPI.put(`/api/builder/${currentUserId}`, payload);
        window.notifyMessage(
          "Success",
          "Builder updated successfully",
          "success"
        );
      } else {
        response = await axiosAPI.post("/api/builder/add-builder", payload);

        window.notifyMessage(
          "Success",
          "Builder added successfully",
          "success"
        );
      }
      hideModal("newUserModal");
      getBuilders();
      removeFormData();
      setIsEditMode(false);
      setIsLoading(false);
      // window.location.reload(); // Reload page to reflect changes in the Property list
      closeModal();
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        window.notifyMessage("Error", error.response.data.message, "danger");
      } else {
        window.notifyMessage("Error", "There was an error!", "danger");
      }
    }
  };

  // Edit Modal Open
  const openEditModal = (id) => {
    setIsEditMode(true);
    setCurrentUserId(id);
    console.log(id);

    // Find the notification with this ID and populate the form
    const selectedProperty = builders.find((enq) => enq.id === id);
    console.log("Open edit modal", selectedProperty);
    if (selectedProperty) {
      setFormData({
        fullName: selectedProperty.name,
        phoneNumber: selectedProperty.phone_number,
        address: selectedProperty.address,
        logoUrl: selectedProperty.logo_url,
      });
    }

    const modal = new window.bootstrap.Modal(
      document.getElementById("newUserModal")
    );
    modal.show();
  };

  // console.log(enquiries)

  const handleDelete = async (id) => {
    console.log(id);
    const isConfirmed = window.confirm("Are you sure you want to delete this?");
    if (!isConfirmed) return;

    try {
      const response = await axiosAPI.delete(`/api/builder/${id}`);
      window.notifyMessage("Success", "Deleted successfully", "success");
      getBuilders();
    } catch (error) {
      console.error("Error deleting:", error);
      window.notifyMessage(
        "Error",
        "An error occurred while deleting.",
        "danger"
      );
    }
  };

  // Close Modal
  const closeModal = () => {
    setIsEditMode(false);
    removeFormData();
    setCurrentUserId(null);
  };

  const openAddModal = () => {
    showModal("newUserModal");
  };

  return (
    <div className="container">
      <div className="page-inner">
        <div className="d-flex justify-content-end align-items-end flex-column flex-md-row">
          <div>
            <button
              type="button"
              className="btn btn-dark btn-round mb-4"
              onClick={() => openAddModal()}
            >
              Add Builder
            </button>
          </div>
        </div>

        {/* Modal */}
        <div
          className="modal fade"
          id="newUserModal"
          tabIndex="-1"
          aria-labelledby="newUserModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="newUserModalLabel">
                  {isEditMode ? "Edit Builder" : "Add Builder"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={closeModal}
                ></button>
              </div>

              <div className="modal-body">
                <form onSubmit={handleSubmit}>
                  {/* Property Name (Input Field) */}
                  <div className="mb-3">
                    <label htmlFor="fullName" className="form-label">
                      Full Name
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="fullName"
                      placeholder="Enter Your Name"
                      value={formData.fullName}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  {/* Phone Number Field (Input Field) */}
                  <div className="mb-3">
                    <label htmlFor="phoneNumber" className="form-label">
                      Phone Number
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="phoneNumber"
                      maxLength={10}
                      placeholder="Enter Phone Number"
                      value={formData.phoneNumber}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (/^\d*$/.test(value)) {
                          // Only allow digits
                          setFormData({ ...formData, phoneNumber: value });
                        }
                      }}
                      required
                    />
                  </div>

                  {/* Address (Input Field) */}
                  <div className="mb-3">
                    <label htmlFor="address" className="form-label">
                      Address
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="address"
                      placeholder="Enter Thumbnail Url"
                      value={formData.address}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  {/* Logo Url (Input Field) */}
                  <div className="mb-3">
                    <label htmlFor="logoUrl" className="form-label">
                      Logo Url
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="logoUrl"
                      placeholder="Enter Thumbnail Url"
                      value={formData.logoUrl}
                      onChange={handleChange}
                    />
                  </div>

                  {/* 
                  <button
                    type="submit"
                    className="btn btn-primary btn-round btn-sm"
                  >
                    {isEditMode ? "Update Enquiry" : "Add Enquiry"}
                  </button> */}
                  <button
                    type="submit"
                    className="btn btn-primary btn-round btn-sm"
                    disabled={isLoading} // Disable button while isLoading
                  >
                    {isLoading ? (
                      <FaSpinner className="spinner" spin /> // Loader icon from react-icons
                    ) : isEditMode ? (
                      "Update Builder"
                    ) : (
                      "Add Builder"
                    )}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>

        {/* Notification Table */}
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-header d-flex justify-content-between align-items-center flex-wrap gap-3">
                {/* Left Section - User Details */}
                <div className="d-flex align-items-center">
                  <h4 className="card-title mb-0">
                    All Builders ({builders?.length})
                  </h4>
                </div>
              </div>
              <div className="card-body">
                <div className="table-responsive">
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th>Full Name</th>
                        <th>Address</th>
                        <th>Phone Number</th>
                        <th>Logo Url</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        // Show a loading state when data is being fetched
                        <tr>
                          <td colSpan="9" className="text-center">
                            <div
                              style={{
                                position: "fixed",
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                zIndex: 9999,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <div
                                className="spinner-border text-success"
                                role="status"
                                style={{ width: "3rem", height: "3rem" }}
                              >
                                <span className="visually-hidden">
                                  Loading...
                                </span>
                              </div>
                            </div>
                          </td>
                        </tr>
                      ) : notFoundMessage ? (
                        <tr>
                          <td colSpan="9" className="text-center text-danger">
                            {notFoundMessage}
                          </td>
                        </tr>
                      ) : builders.length == 0 ? (
                        // Show a "No Data Found" message when no data is available
                        <tr>
                          <td colSpan="9" className="text-center">
                            No Data Found
                          </td>
                        </tr>
                      ) : (
                        // Render the list of enquiries if data is available
                        builders.map((enquiry) => {
                          return (
                            <tr key={enquiry.id}>
                              <td>{enquiry.name}</td>
                              <td>{enquiry.address}</td>
                              <td>{enquiry.phone_number}</td>
                              <td>
                                <img
                                  src={enquiry.logo_url}
                                  alt="logo url"
                                  style={{ width: "100px" }}
                                />
                              </td>{" "}
                              <td>
                                <button
                                  className="btn btn-icon btn-round btn-dark btn-sm me-2"
                                  onClick={() => openEditModal(enquiry.id)}
                                >
                                  <i className="fas fa-edit"></i>
                                </button>
                                <button
                                  className="btn btn-icon btn-round btn-danger btn-sm me-2"
                                  onClick={() => handleDelete(enquiry.id)}
                                >
                                  <i className="fas fa-trash"></i>
                                </button>
                              </td>
                            </tr>
                          );
                        })
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <Pagination totalPages={totalPages} setPage={setPage} page={page} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Builder;
